import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Ui2DatepickerModule } from '@innovation-os-ng/ui/ui2-datepicker';
import { TranslateModule, TranslateRegistry } from '@itonics/ngx-translate-simple';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { FilterDateComponent } from './components/filter-date/filter-date.component';

/**
 * Translations
 */
import { en } from './i18n/en';

@NgModule({
  declarations: [FilterDateComponent],
  imports: [CommonModule, Ui2DatepickerModule, FormsModule, TranslateModule, SharedServicesModule],
  exports: [FilterDateComponent]
})
export class FilterDateModule {
  constructor(private readonly translateRegistry: TranslateRegistry) {
    // Translate
    this.translateRegistry.registerLoader((lang) =>
      // resolve to the language selected or en if it does not exist
      Promise.resolve({ en /* de, es, fr, it, jp, cn */ }[lang] || en)
    );
  }
}
